import React from "react";

export interface AppointmentSecondaryTabItem {
  id: string;
  label: string;
  disabled?: boolean;
  disabledTitle?: string;
}

interface AppointmentSecondaryTabsProps {
  eyebrow: string;
  tabs: AppointmentSecondaryTabItem[];
  activeId: string;
  onChange: (id: string) => void;
}

/** Same header / sub-tab row as Time Center `SecondaryTabs`. */
export default function AppointmentSecondaryTabs({ eyebrow, tabs, activeId, onChange }: AppointmentSecondaryTabsProps) {
  return (
    <div className="mb-6 border-b border-slate-200">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between sm:gap-6">
        <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-800 sm:pb-4">{eyebrow}</span>
        <div className="-mb-px flex max-w-full flex-nowrap items-end gap-6 overflow-x-auto scrollbar-hide sm:gap-7">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              disabled={tab.disabled}
              title={tab.disabled ? tab.disabledTitle : undefined}
              onClick={() => {
                if (!tab.disabled) onChange(tab.id);
              }}
              className={`relative flex-shrink-0 whitespace-nowrap border-b-2 pb-3 text-sm transition ${
                tab.disabled
                  ? "cursor-not-allowed border-transparent text-slate-300"
                  : activeId === tab.id
                    ? "border-indigo-600 font-semibold text-slate-900"
                    : "border-transparent font-medium text-slate-700 hover:border-slate-300 hover:text-slate-900"
              }`}>
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
